import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.scrap');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-scrap',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.scrap/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f5f7f4;
  color: #17202a;
}

.page-wrap {
  max-width: 1360px;
  margin: 0 auto;
  padding: 34px 28px 56px;
}

.work-header,
.filter-panel,
.table-panel {
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(23, 32, 42, 0.06);
}

.work-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
}

.header-copy h1 {
  margin: 6px 0 8px;
  font-size: 30px;
  font-weight: 850;
  letter-spacing: 0;
}

.header-copy p {
  margin: 0;
  max-width: 720px;
  color: #657069;
  line-height: 1.65;
}

.eyebrow,
.section-kicker {
  color: #b28921;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.mini-stat {
  min-width: 116px;
  padding: 12px 14px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #fbfcfa;
}

.mini-stat span {
  display: block;
  color: #78827c;
  font-size: 12px;
  font-weight: 800;
}

.mini-stat strong {
  display: block;
  margin-top: 4px;
  color: #10375c;
  font-size: 23px;
  font-weight: 850;
}

.filter-panel,
.table-panel {
  margin-top: 18px;
  overflow: hidden;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px;
  border-bottom: 1px solid #e5e8e2;
}

.panel-title h2 {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 850;
}

.panel-meta {
  color: #68736d;
  font-size: 13px;
  font-weight: 850;
}

button {
  font: inherit;
}

.text-btn,
.filter-chip,
.table-btn,
.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.16s ease;
}

.text-btn {
  border: 0;
  background: transparent;
  color: #10375c;
  font-size: 13px;
  font-weight: 850;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 20px 22px 22px;
}

.filter-chip {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4d5751;
  font-size: 13px;
  font-weight: 850;
}

.filter-chip em {
  min-width: 22px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef0ed;
  color: #68736d;
  font-style: normal;
  font-size: 11px;
}

.filter-chip.is-active {
  border-color: #10375c;
  background: #eaf2ff;
  color: #10375c;
}

.filter-chip.is-active em {
  background: #10375c;
  color: #fff;
}

.filter-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 22px 22px;
  color: #77827b;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
}

.data-table th {
  padding: 13px 18px;
  background: #f2f4f1;
  color: #657069;
  font-size: 12px;
  font-weight: 850;
  text-align: left;
}

.data-table td {
  padding: 16px 18px;
  border-top: 1px solid #edf0eb;
  vertical-align: middle;
}

.data-table tbody tr {
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: #fbfcfa;
}

.title-cell {
  min-width: 380px;
}

.title-cell strong {
  display: block;
  color: #17202a;
  font-weight: 850;
  line-height: 1.45;
}

.title-cell span,
.date-text {
  display: block;
  margin-top: 4px;
  color: #88928c;
  font-size: 12px;
}

.budget,
.deadline {
  color: #10375c;
  font-weight: 850;
}

.keyword-pill {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #fff2d6;
  color: #93680d;
  font-size: 12px;
  font-weight: 850;
}

.table-btn {
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4c5751;
  font-size: 13px;
  font-weight: 850;
}

.table-btn.danger {
  color: #aa3a31;
}

.table-btn:hover,
.page-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.loading-state,
.empty-state {
  display: grid;
  place-items: center;
  gap: 12px;
  min-height: 280px;
  padding: 36px;
  color: #717b75;
  text-align: center;
}

.empty-state i {
  color: #b7beb7;
  font-size: 34px;
}

.empty-state strong {
  color: #17202a;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dfe3db;
  border-top-color: #10375c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 18px 22px 22px;
  border-top: 1px solid #edf0eb;
}

.page-btn {
  min-width: 36px;
  height: 36px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4d5751;
  font-weight: 850;
}

.page-btn.is-active {
  border-color: #10375c;
  background: #10375c;
  color: #fff;
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 980px) {
  .page-wrap {
    padding: 20px 14px 40px;
  }
  .work-header,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions {
    width: 100%;
  }
  .mini-stat {
    flex: 1;
  }
}
/* Library-tone compact overrides */
:host {
  background: #fafafa;
  color: #18181b;
}

.page-wrap {
  max-width: 1400px;
  padding: 20px 24px 60px;
}

.work-header {
  align-items: flex-start;
  padding: 0 0 12px;
  margin-bottom: 16px;
  border: 0;
  border-bottom: 1px solid #e4e4e7;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-copy h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.header-copy p {
  max-width: none;
  font-size: 12px;
  line-height: 1.45;
  color: #71717a;
}

.eyebrow,
.section-kicker {
  color: #0f766e;
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
}

.mini-stat {
  min-width: auto;
  height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border-color: #e4e4e7;
  border-radius: 999px;
  background: #f4f4f5;
}

.mini-stat span,
.mini-stat strong {
  display: inline;
  margin: 0;
  font-size: 11px;
  line-height: 1;
}

.mini-stat strong {
  color: #52525b;
}

.filter-panel,
.table-panel {
  margin-top: 12px;
  border-color: #e4e4e7;
  box-shadow: none;
}

.panel-head {
  min-height: 48px;
  padding: 12px 14px;
  border-bottom-color: #f4f4f5;
  background: #ffffff;
}

.panel-title h2 {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
}

.panel-meta {
  font-size: 12px;
  font-weight: 600;
}

.text-btn,
.filter-chip,
.table-btn,
.page-btn {
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.text-btn {
  color: #0f766e;
}

.filter-row {
  gap: 6px;
  padding: 12px 14px 14px;
}

.filter-chip {
  min-height: 30px;
  border-color: #e4e4e7;
}

.filter-chip.is-active {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.filter-chip.is-active em {
  background: #0f766e;
}

.filter-empty {
  padding: 12px 14px 14px;
  font-size: 12px;
}

.data-table th {
  padding: 10px 14px;
  background: #fafafa;
  font-size: 11px;
  font-weight: 650;
}

.data-table td {
  padding: 12px 14px;
}

.title-cell strong,
.budget,
.deadline {
  font-weight: 650;
}

.keyword-pill,
.table-btn {
  min-height: 26px;
  font-size: 11px;
  font-weight: 600;
}

.keyword-pill {
  background: #ecfdf5;
  color: #0f766e;
}

.loading-state,
.empty-state {
  min-height: 220px;
  padding: 42px 20px;
}

.empty-state i {
  font-size: 26px;
}

.empty-state strong {
  font-size: 13px;
  font-weight: 650;
}

.pagination {
  padding: 12px 14px 14px;
}

.page-btn {
  min-width: 30px;
  height: 30px;
}

.page-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
}

/* Font scale refinement */
.scrap-page {
  font-size: 12px;
}

.header-copy h1 {
  font-size: 16px;
}

.header-copy p,
.panel-meta,
.filter-empty,
.date-text {
  font-size: 11.5px;
}

.panel-title h2 {
  font-size: 14px;
}

.filter-chip,
.table-btn,
.keyword-pill {
  font-size: 11.5px;
}

.title-cell strong,
.budget,
.deadline {
  font-size: 12px;
}

.data-table td {
  font-size: 12px;
}`],
})
export class PageScrapComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public loading: boolean = false;

    public keywordFilters: any[] = [];
    public selectedKeyword: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.loadKeywords();
        await this.load();
        await this.service.render();
    }

    private async loadKeywords() {
        try {
            let res = await wiz.call("keywords");
            if (res.code === 200) {
                this.keywordFilters = res.data.keywords || [];
            }
        } catch { }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        try {
            let params: any = { page: this.page, dump: this.dump };
            if (this.selectedKeyword) params.keyword = this.selectedKeyword;

            let res = await wiz.call("list", params);
            if (res.code === 200) {
                this.items = res.data.rows || [];
                this.total = res.data.total || 0;
            }
        } catch { }

        this.loading = false;
        await this.service.render();
    }

    public async filterByKeyword(keyword: string) {
        this.selectedKeyword = this.selectedKeyword === keyword ? '' : keyword;
        this.page = 1;
        await this.load();
    }

    public async clearFilter() {
        this.selectedKeyword = '';
        this.page = 1;
        await this.load();
    }

    public async unscrap(item: any, event: Event) {
        event.stopPropagation();
        let res = await this.service.modal.show({
            title: '스크랩 해제',
            message: '이 공고를 관심 목록에서 제거하시겠습니까?',
            action: '해제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;

        try {
            let result = await wiz.call("unscrap", { notice_no: item.notice_no });
            if (result.code === 200) {
                this.items = this.items.filter(i => i.notice_no !== item.notice_no);
                this.total--;
                let kw = this.keywordFilters.find(k => k.keyword === item.matched_keyword);
                if (kw) {
                    kw.count--;
                    if (kw.count <= 0) this.keywordFilters = this.keywordFilters.filter(k => k.keyword !== item.matched_keyword);
                }
                await this.service.render();
            }
        } catch { }
    }

    public openDetail(item: any) {
        let detailItem = { ...item };
        if (typeof detailItem.attachments === 'string') {
            try { detailItem.attachments = JSON.parse(detailItem.attachments); } catch { detailItem.attachments = []; }
        }
        localStorage.setItem('crawl_notice', JSON.stringify(detailItem));
        this.service.href(`/crawl/${item.notice_no}`);
    }

    public openProject(item: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!item?.notice_no) return;
        this.service.href(`/analysis/${encodeURIComponent(item.notice_no)}?from=project`);
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.load();
    }

    public get pageRange(): number[] {
        let pages: number[] = [];
        let start = Math.max(1, this.page - 2);
        let end = Math.min(this.totalPages, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public getDday(deadline: string): number | null {
        if (!deadline) return null;
        try {
            let dt: Date;
            if (deadline.includes('-')) {
                dt = new Date(deadline);
            } else if (deadline.length >= 8) {
                let y = deadline.substring(0, 4);
                let m = deadline.substring(4, 6);
                let d = deadline.substring(6, 8);
                dt = new Date(`${y}-${m}-${d}`);
            } else {
                return null;
            }
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            dt.setHours(0, 0, 0, 0);
            return Math.ceil((dt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        } catch {
            return null;
        }
    }

    public getDdayColor(days: number | null): string {
        if (days === null) return 'text-stone-400';
        if (days < 0) return 'text-stone-400';
        if (days <= 3) return 'text-red-500';
        if (days <= 7) return 'text-orange-500';
        if (days <= 14) return 'text-yellow-600';
        return 'text-emerald-600';
    }

    public getDdayText(days: number | null): string {
        if (days === null) return '-';
        if (days === 0) return 'D-Day';
        if (days > 0) return `D-${days}`;
        return `D+${Math.abs(days)}`;
    }

    public formatBudget(amount: number) {
        if (!amount) return '-';
        if (amount >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        if (amount >= 10000) return (amount / 10000).toFixed(0) + '만원';
        return amount.toLocaleString() + '원';
    }

    public formatDate(dt: string) {
        if (!dt || dt.length < 8) return '-';
        if (dt.includes('-')) return dt.substring(0, 10);
        return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6, 8);
    }
}

export default PageScrapComponent;